import React from 'react';
import './App.css';
import {BrowserRouter as Router, Route, Routes} from 'react-router-dom';
import Login from './Login';
import Landing from './Landing';
import About from './About';
import Profile from './Profile';
import UserManagement from './UserManagement';
import AdvancedSearch from './AdvancedSearch';
import ForgotPassword from './ForgotPassword';
import PasswordRecoveryEntry from './PasswordRecoveryEntry';


const App = () => {
    return (
        <Router>
            <Routes>
                <Route path="/landing" element={<Landing/>}/>
                <Route path="/about" element={<About/>}/>
                <Route path="/profile" element={<Profile/>}/>
                <Route path="/userManagement" element={<UserManagement/>}/>
                <Route path="/advancedSearch" element={<AdvancedSearch/>}/>
                <Route path="/" element={<Login/>}/>
                <Route path="/forgotPassword" element={<ForgotPassword/>}/>
                <Route path="/passwordRecoveryEntry" element={<PasswordRecoveryEntry/>}/>
            </Routes>
        </Router>
    );
};

export default App;
